export enum BenefitClaimStatus {
  Unclaimed = 0,
  Unprocessed = 1,
  Processed = 2,
  Refunded = 3,
  Deleted = 4,
  OutOfStock = 5,
}
